import styled from 'styled-components';

export const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.colors.red};
  margin-top: 0.5rem;
  font-size: 14px;
`;
